class FormUtils {
	checkData(data, exclude = []) {
		var error = null;
		exclude.push('inputData');
		exclude.push('subscriptionId');
		exclude.push('lastname');
		exclude.push('addressId');
		exclude.push('orderId');
		exclude.push('subscriptionParentId');
		exclude.push('accepted_email');
		exclude.push('accepted_sms');
		exclude.push('accepted_whatsapp');
		exclude.push('position');
		for (let fieldItem in data) {
			if (exclude.indexOf(fieldItem) < 0) {
				if (data[fieldItem].error) {
					error = data[fieldItem].msg;
				} else if (!data[fieldItem].value) {
					if (fieldItem === 'checkedEmail' || fieldItem == 'checkedWhatsapp') {
					} else {
						error = 'Você precisa preencher todos os campos para avançar.';
					}
				}
			}
		}

		return error;
	}

	checkAllErrors(data, exclude = []) {
		let errObj = {};

		exclude.push('inputData');
		exclude.push('subscriptionId');
		exclude.push('lastname');
		exclude.push('addressId');
		exclude.push('orderId');

		const errorMsgs = {
			name: 'Insira o nome completo do assinante',
			cpf: 'Insira um CPF válido',
			phone: 'Telefone com DDD válido',
			birthday: 'Data de nascimento inválida',
			gender: 'Insira o sexo',
			email: 'Insira o e-mail no formato nome@exemplo.com'
		};

		const errorEmptyMsgs = {
			name: 'Insira o nome completo do assinante',
			cpf: 'Insira o CPF',
			phone: 'Insira o telefone com o DDD',
			birthday: 'Insira a data de nascimento',
			gender: 'Insira o sexo',
			email: 'Insira o e-mail no formato nome@exemplo.com'
		};

		for (let fieldItem in data) {
			if (exclude.indexOf(fieldItem) < 0) {
				if (data[fieldItem].msg === 'Campo vazio') {
					errObj = Object.assign(errObj, {
						[fieldItem]: errorEmptyMsgs[fieldItem]
					});
				} else if (data[fieldItem].error) {
					errObj = Object.assign(errObj, {
						[fieldItem]: errorMsgs[fieldItem]
					});
				}
			}
		}

		return errObj;
	}

	checkAddressErrors(data, exclude = []) {
		let errObj = {};
		exclude.push('complement');

		const errorEmptyMsgs = {
			cep: 'Insira o CEP',
			address: 'Insira o endereço',
			district: 'Insira o bairro',
			number: 'Insira o número',
			state: 'Insira o estado',
			city: 'Insira a cidade'
		};

		const errorMsgs = {
			cep: 'CEP inválido',
			address: 'Endereço inválido',
			district: 'Bairro inválido',
			number: 'Número inválido',
			state: 'Estado inválido',
			city: 'Cidade inválida'
		};

		for (let fieldItem in data) {
			if (exclude.indexOf(fieldItem) < 0) {
				if (data[fieldItem].msg === 'Campo vazio') {
					errObj = Object.assign(errObj, {
						[fieldItem]: errorEmptyMsgs[fieldItem]
					});
				} else if (data[fieldItem].error) {
					errObj = Object.assign(errObj, {
						[fieldItem]: errorMsgs[fieldItem]
					});
				}
			}
		}

		return errObj;
	}

	formatData(data) {
		let sendData = {};
		for (let fieldItem in data) {
			sendData[fieldItem] = data[fieldItem].value;
		}
		return sendData;
	}
}

export default new FormUtils();
